import { hexColorToRGBA } from '../util.js'
import { componentStyle, seniorCfg } from '../common/common'
import { BASE_ECHARTS_SELECT, DEFAULT_TOOLTIP } from '@/views/chart/chart/chart'
import * as echartsUtils from '@/utils/echartsUtils'
import { BASE_BAR2 } from '@/views/chart/chart/chart2'

export function baseBarOption(chart_option, chart, activeParam) {


  // 处理shape attr
/*  let customAttr = {}
  if (chart.customAttr) {
    customAttr = JSON.parse(chart.customAttr)
    if (customAttr.color) {
      chart_option.color = customAttr.color.colors
    }
    // tooltip
    if (customAttr.tooltip) {
      const tooltip = JSON.parse(JSON.stringify(customAttr.tooltip))
      const reg = new RegExp('\n', 'g')
      tooltip.formatter = tooltip.formatter.replace(reg, '<br/>')
      chart_option.tooltip = tooltip

      const bgColor = tooltip.backgroundColor ? tooltip.backgroundColor : DEFAULT_TOOLTIP.backgroundColor
      chart_option.tooltip.backgroundColor = bgColor
      chart_option.tooltip.borderColor = bgColor
    }
  }
  // 处理data
  if (chart.data) {
    chart_option.title.text = chart.title
    chart_option.xAxis.data = chart.data.x
    for (let i = 0; i < chart.data.series.length; i++) {
      const y = chart.data.series[i]
      // color
      y.itemStyle = {
        color: hexColorToRGBA(customAttr.color.colors[i % customAttr.color.colors.length], customAttr.color.alpha)
      }
      // size
      if (customAttr.size) {
        if (customAttr.size.barDefault) {
          y.barWidth = null
          y.barGap = null
        } else {
          y.barWidth = customAttr.size.barWidth
          y.barGap = customAttr.size.barGap
        }
      }
      // label
      if (customAttr.label) {
        y.label = customAttr.label
      }
      y.type = 'bar'
      y.selectedMode = true
      y.select = BASE_ECHARTS_SELECT
      chart_option.legend.data.push(y.name)
      chart_option.series.push(y)
    }
  }*/
  componentStyle(chart_option, chart)
  seniorCfg(chart_option, chart)
  return chart_option
}

export function stackBarOption2(chart_option, chart) {
 // baseBarOption(chart_option, chart)

  console.log("stackBarOption2")


  let customAttr = {}
  if (chart.customAttr) {
    customAttr = JSON.parse(chart.customAttr)
    if (customAttr.color) {
      chart_option.color = customAttr.color.colors
    }
    // tooltip
    if (customAttr.tooltip) {
      const tooltip = JSON.parse(JSON.stringify(customAttr.tooltip))
      const reg = new RegExp('\n', 'g')
      tooltip.formatter = tooltip.formatter.replace(reg, '<br/>')
      chart_option.tooltip = tooltip

      const bgColor = tooltip.backgroundColor ? tooltip.backgroundColor : DEFAULT_TOOLTIP.backgroundColor
      chart_option.tooltip.backgroundColor = bgColor
      chart_option.tooltip.borderColor = bgColor
    }
  }

  console.log(chart_option)
 //chart_option.yAxis
  console.log(chart.data.x)
  let data_arr_year=[]
  let data_arr_month=[]
  chart.data.x.forEach((item, index) => {
    let split = item.split("\n");
    if (split.length < 2) {
      split = item.split("-");
    }
    const year = parseInt(split[0]), month = parseInt(split[1]);
    data_arr_year.push(year);
    data_arr_month.push(month);
  });

  console.log(data_arr_year);
  console.log(data_arr_month);

 // chart_option.series=[]
  chart_option.yAxis=[]
  if (chart.data) {
    chart_option.title.text = chart.title
    chart_option.xAxis.data = chart.data.x
    for (let i = 0; i < chart.data.series.length; i++) {
      const y = chart.data.series[i]
      console.log("y---")
      console.log(y)

      let series= {
        "stack": "stack",
        "barMaxWidth": 40,
        "data": [3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782],
        "name": "2021-预估",
        "itemStyle": {
          // "color": new echarts.graphic.LinearGradient(0,0,0,1,[{offset: 0, color: '#4864a5'},{offset: 0.5, color: '#4864a5'},{offset: 1, color: '#4864a5'}]),
          "borderRadius": 0
        },
        "type": "bar",
        "barMinHeight": 1
      };

      series.name=y.name

      let yAxis= {
        "axisLabel": {
          "formatter": "f$function(value){ return formatNumber(value,'#,###'); }",
          "color": "#616161",
          "show": true
        },
        "axisLine": {
          "lineStyle": {
            "color": "#939393"
          },
          "show": true
        },
        "show": true,
        "axisTick": {
          "show": true
        },
        "name": "预估",
        "splitLine": {
          "lineStyle": {
            "color": "#e0dfdf",
            "width": 1,
            "type": "solid"
          },
          "show": true
        }
      };

        yAxis.name=y.name;

     // y.type = 'bar'
     // y.selectedMode = true
     // y.select = BASE_ECHARTS_SELECT
     // chart_option.legend.data.push(y.name)
      chart_option.yAxis.push(yAxis)
      chart_option.series.push(series)
    }
  }



  // ext
  chart_option.series.forEach(function(s) {
    s.stack = 'stack'
    s.emphasis = {
      focus: 'series'
    }
  })
  let chart_option2 = echartsUtils.loopChartJson(chart_option);
  return chart_option2
}

export function barOption2(chart_option, chart) {

  console.log("barOption2")
  console.log(chart_option)
  baseBarOption(chart_option, chart)
  return chart_option
}

export  function horizontalBarOption2(chart_option,chart){
  console.log("horizontalBarOption2")
  console.log(chart_option)
  baseBarOption(chart_option, chart)
  return chart_option
}

